import { GeneralContext } from "../context/GeneralContext"
import { useContext } from "react"
import cuestionarioService from '../services/cuestionario.js';

export const useModo = () => {

    const { user } = useContext(GeneralContext);


    const cambiarModoIniciacion = async() => {

        const response = await cuestionarioService.setModoIniciacion(user);
        return response;

    }
    const cambiarModoExperto = async() => {

        const response = await cuestionarioService.setModoExperto(user);
        return response;
    }

    return { cambiarModoIniciacion, cambiarModoExperto };
}